import { render, staticRenderFns } from "./nullified_project.vue?vue&type=template&id=25c65539"
import script from "./nullified_project.vue?vue&type=script&lang=js"
export * from "./nullified_project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports